import './admin-footer.scss';

export const AdminFooter = () => {
  return (
    <div className="admin-footer">
      <div>
        Questions about your equipment rental software? Contact{' '}
        <a href="mailto:support@quipli.com">support@quipli.com</a>
      </div>
    </div>
  );
};
